class RRRProductInformationTabs {
  constructor(section) {
    this.section = section;

    this.tabs = Array.from(
      section.querySelectorAll('[data-rrr-tab]')
    );

    this.accordions = Array.from(
      section.querySelectorAll('[data-rrr-accordion-trigger]')
    );

    this.panels = Array.from(
      section.querySelectorAll('[data-rrr-panel]')
    );

    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.animationEnabled = section.dataset.animation === 'true';

    if (!this.panels.length) return;

    this.activeIndex = this.getInitialIndex();

    this.bindEvents();
    this.syncMode();
  }

  getInitialIndex() {
    const activePanelIndex = this.panels.findIndex((panel) =>
      panel.classList.contains('is-active')
    );

    return activePanelIndex >= 0 ? activePanelIndex : 0;
  }

  bindEvents() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        this.activate(index, false);
      });

      tab.addEventListener('keydown', (event) => {
        this.handleDesktopKeyboard(event, index);
      });
    });

    this.accordions.forEach((accordion, index) => {
      accordion.addEventListener('click', () => {
        this.activate(index, false);
      });

      accordion.addEventListener('keydown', (event) => {
        this.handleMobileKeyboard(event, index);
      });
    });

    if (typeof this.mobileQuery.addEventListener === 'function') {
      this.mobileQuery.addEventListener('change', () => {
        this.syncMode();
      });
    } else {
      this.mobileQuery.addListener(() => {
        this.syncMode();
      });
    }
  }

  syncMode() {
    this.activate(this.activeIndex, false, false);
  }

  activate(index, focusControl = false, animate = true) {
    if (index < 0 || index >= this.panels.length) return;

    this.activeIndex = index;

    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;

      tab.classList.toggle('is-active', active);
      tab.setAttribute(
        'aria-selected',
        active ? 'true' : 'false'
      );
      tab.setAttribute(
        'tabindex',
        active ? '0' : '-1'
      );
    });

    this.accordions.forEach((accordion, accordionIndex) => {
      const active = accordionIndex === index;

      accordion.classList.toggle('is-active', active);
      accordion.setAttribute(
        'aria-expanded',
        active ? 'true' : 'false'
      );
    });

    this.panels.forEach((panel, panelIndex) => {
      const active = panelIndex === index;

      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
      panel.classList.remove('is-entering');

      if (
        active &&
        animate &&
        this.animationEnabled
      ) {
        window.requestAnimationFrame(() => {
          panel.classList.add('is-entering');
        });
      }
    });

    if (this.mobileQuery.matches) {
      const accordion = this.accordions[index];

      if (accordion) {
        accordion.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });

        if (focusControl) {
          accordion.focus({
            preventScroll: true
          });
        }
      }

      return;
    }

    const tab = this.tabs[index];

    if (tab) {
      tab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });

      if (focusControl) {
        tab.focus({
          preventScroll: true
        });
      }
    }
  }

  handleDesktopKeyboard(event, currentIndex) {
    let nextIndex = null;

    switch (event.key) {
      case 'ArrowRight':
        nextIndex =
          (currentIndex + 1) % this.tabs.length;
        break;

      case 'ArrowLeft':
        nextIndex =
          (currentIndex - 1 + this.tabs.length) %
          this.tabs.length;
        break;

      case 'Home':
        nextIndex = 0;
        break;

      case 'End':
        nextIndex = this.tabs.length - 1;
        break;

      default:
        return;
    }

    event.preventDefault();
    this.activate(nextIndex, true);
  }

  handleMobileKeyboard(event, currentIndex) {
    let nextIndex = null;

    switch (event.key) {
      case 'ArrowDown':
        nextIndex =
          (currentIndex + 1) % this.accordions.length;
        break;

      case 'ArrowUp':
        nextIndex =
          (currentIndex - 1 + this.accordions.length) %
          this.accordions.length;
        break;

      case 'Home':
        nextIndex = 0;
        break;

      case 'End':
        nextIndex = this.accordions.length - 1;
        break;

      default:
        return;
    }

    event.preventDefault();
    this.activate(nextIndex, true);
  }

  activateBlock(blockId) {
    const index = this.panels.findIndex(
      (panel) =>
        panel.dataset.blockId === String(blockId)
    );

    if (index >= 0) {
      this.activate(index, false);
    }
  }
}

function initializeRRRProductInformationTabs(
  container = document
) {
  container
    .querySelectorAll('[data-rrr-product-tabs]')
    .forEach((section) => {
      if (
        section.dataset.rrrTabsInitialized === 'true'
      ) {
        return;
      }

      section.dataset.rrrTabsInitialized = 'true';

      section.rrrProductTabs =
        new RRRProductInformationTabs(section);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initializeRRRProductInformationTabs();
    }
  );
} else {
  initializeRRRProductInformationTabs();
}

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializeRRRProductInformationTabs(event.target);
  }
);

document.addEventListener(
  'shopify:block:select',
  (event) => {
    const section = event.target.closest(
      '[data-rrr-product-tabs]'
    );

    const blockId = event.detail?.blockId;

    if (!section || !blockId) return;

    section.rrrProductTabs?.activateBlock(blockId);
  }
);